/* Zusatzzeilen unter dem LP-Live-Preis (snippets/lp-price-live.liquid) nur bei aktivem Rabatt einblenden.
   Quelle: Event "lf:discount-resolved" und sessionStorage "scDiscountData" aus assets/bs-discount-apply.min.js.
   Gleiche Zuordnung wie dort: Product-ID in detail.products oder Collection-ID in detail.collections.
   Das Snippet kann mehrfach pro Seite vorkommen; jeder Lauf übernimmt nur noch nicht gebundene Boxen. */
(function () {
  var boxes = Array.prototype.filter.call(document.querySelectorAll('[data-lp-pricebox]'), function (box) {
    if (box.hasAttribute('data-lp-pricebox-bound')) return false;
    box.setAttribute('data-lp-pricebox-bound', '');
    return true;
  });
  if (!boxes.length) return;

  function ids(list) {
    return (list || []).map(function (id) {
      var parts = String(id).trim().split('/');
      return parts[parts.length - 1];
    });
  }

  function applies(box, detail) {
    if (!detail) return false;
    var productId = String(box.getAttribute('data-product-id') || '');
    if (productId && ids(detail.products).indexOf(productId) !== -1) return true;
    var collections = ids(detail.collections);
    return (box.getAttribute('data-collections') || '').split(',').some(function (id) {
      return id !== '' && collections.indexOf(id) !== -1;
    });
  }

  function update(detail) {
    boxes.forEach(function (box) {
      var lines = box.querySelector('[data-lp-discount-lines]');
      if (lines) lines.hidden = !applies(box, detail);
    });
  }

  var initial = null;
  try {
    initial = JSON.parse(sessionStorage.getItem('scDiscountData'));
  } catch (e) {}
  update(initial);

  document.addEventListener('lf:discount-resolved', function (event) {
    update(event.detail);
  });
})();
